import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import Skeleton from "react-loading-skeleton";
import { TbEditCircle } from "react-icons/tb";
import { useLocation } from 'react-router-dom';
import { onImageHandler } from '../../components/UploadImageOnBucket';
import { UpdateProfileSlice } from '../../redux/features/AccountManagement';

const MyAccount = () => {

  const {state} = useLocation();
  const dispatch = useDispatch();
  const [imageLoading, setImageLoading] = useState(false);

  const [iState, setUpdate] = useState({
    fullName: '',
    email: '',
    contact: '',
    address: '',
  });

  const [errors, setErrors] = useState({});

  useEffect(()=>{
    setUpdate({
      id:state?._id,
      fullName: state?.name,
      email: state?.email,
      contact: state?.contactNo,
      address: state?.address,
      profileImage:state?.profileImage
    })
  },[state])

  console.log(iState)

  const handleUpload = async ({ e, setImageLoading, setUpdate }) => {
    setImageLoading(true);
    const data = await onImageHandler(e);
    setUpdate((prev) => ({ ...prev, [e.target.name]: data[1].location }));
    setImageLoading(false);
  };

  const validate = () => {
    const tempErrors = {};
    if (!iState.fullName.trim()) tempErrors.fullName = 'Full name is required';
    if (!iState.email.trim()) {
      tempErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(iState.email)) {
      tempErrors.email = 'Email is invalid';
    }
    if (!iState.contact.trim()) {
      tempErrors.contact = 'Contact number is required';
    } else if (!/^\d{10}$/.test(iState.contact)) {
      tempErrors.contact = 'Contact must be a 10-digit number';
    }
    if (!iState.address.trim()) tempErrors.address = 'Address is required';
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleChange = (e) => {
    setUpdate({ ...iState, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      const data ={
        "name":iState?.fullName, 
        "contactNo":iState?.contact, 
        "profileImage":iState?.profileImage,
        "email":iState?.email,
        "address":iState?.address
    }
console.log(data)
    dispatch(UpdateProfileSlice({id:iState?.id,data}))?.then((res)=>{
      console.log(res);
    })

    }
  };

  return (
    <>
      <>
  <div className="WrapperArea">
    <div className="WrapperBox">
      <div className="Small-Wrapper">
       <div className="PasswordBox" style={{ marginBottom: '100px' }}>
      <aside>
        <div className="TitleBox">
          <h2>My Account</h2>
        </div>
        <div className="UploadBox">
                    <div className="Upload" style={{ padding: "0" }}>
                      {imageLoading ? (
                        <Skeleton width={"100%"} height={"130px"} />
                      ) : iState?.profileImage?.length > 0 ? (
                        <div
                          style={{
                            height: "100%",
                            width: "100%",
                            position: "relative",
                          }}
                        >
                          <img
                            src={iState?.profileImage}
                            style={{ height: "100%", width: "100%" }}
                          />
                          <div
                            style={{
                              position: "absolute",
                              top: "5px",
                              right: "10px",
                              cursor: "pointer",
                            }}
                          >
                            <input
                              type="file"
                              name="profileImage"
                              accept=".jpg, .jpeg, .png"
                              onChange={(e) =>
                                handleUpload({ e, setImageLoading, setUpdate })
                              }
                              style={{
                                height: "100%",
                                width: "100%",
                                opacity: "0",
                              }}
                            />
                            <TbEditCircle
                              style={{
                                fontSize: "20px",
                                backgroundColor: "gray",
                                color: "wheat",
                                cursor: "pointer !important",
                                borderRadius: "10px",
                              }}
                            />
                          </div>
                        </div>
                      ) : (
                        <>
                          <i className="fa fa-upload" style={{marginTop:'30px'}}/> <span>Upload </span>
                          <input
                            type="file"
                            accept=".jpg, .jpeg, .png"
                            name="profileImage"
                            onChange={(e) =>
                              handleUpload({ e, setImageLoading, setUpdate })
                            }
                          />
                        </>
                      )}
                    </div>
                  </div>
      </aside>
      <article>
        <form className="CommonForm" onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Full name</label>
            <input
              type="text"
              name="fullName"
              className="form-control"
              placeholder="Enter Full name"
              value={iState.fullName}
              onChange={handleChange}
            />
            {errors.fullName && <small style={{ color: 'red' }}>{errors.fullName}</small>}
          </div>

          <div className="form-group">
            <label>Email address</label>
            <input
              type="text"
              name="email"
              className="form-control"
              placeholder="Enter Email address"
              value={iState.email}
              onChange={handleChange}
            />
            {errors.email && <small style={{ color: 'red' }}>{errors.email}</small>}
          </div>

          <div className="form-group">
            <label>Contact number</label>
            <input
              type="text"
              name="contact"
              className="form-control"
              placeholder="Enter Contact number"
              value={iState.contact}
              onChange={handleChange}
            />
            {errors.contact && <small style={{ color: 'red' }}>{errors.contact}</small>}
          </div>

          <div className="form-group">
            <label>Address</label>
            <input
              type="text"
              name="address"
              className="form-control"
              placeholder="Enter Address"
              value={iState.address}
              onChange={handleChange}
            />
            {errors.address && <small style={{ color: 'red' }}>{errors.address}</small>}
          </div>

          <button type="submit" className="Button">Save Details</button>
        </form>
      </article>
    </div>
      </div>
    </div>
  </div>
</>

    </>
  )
}

export default MyAccount
